import classNames from "classnames";
import { ReactNode } from "react";
import LoanNavItem from "components/v2/loan-nav-item/LoanNavItem";
import MainSidebarSection from "./MainSidebarSection";
import { LoanNavBaseState } from "components/v2/loan-status-chip/loanNavStatusMapping";
import SidebarDivider from "./SidebarDivider";
import SidebarNavItem from "./SidebarNavItem";
import SidebarSection from "./SidebarSection";
import "./loan-centric-sidebar-nav.scss";

export interface LoanCentricSidebarLoanItem {
  readonly id: string;
  readonly label: string;
  readonly baseState: LoanNavBaseState;
  readonly isActive: boolean;
  readonly icon: ReactNode;
}

export interface LoanCentricSidebarProfileItem {
  readonly id: string;
  readonly label: string;
  readonly onClick: () => void;
}

export interface LoanCentricSidebarNavViewProps {
  readonly loans: readonly LoanCentricSidebarLoanItem[];
  readonly profileItems: readonly LoanCentricSidebarProfileItem[];
  readonly isLoading?: boolean;
  readonly onLoanClick?: (loanId: string) => void;
  readonly className?: string;
}

export default function LoanCentricSidebarNavView({
  loans,
  profileItems,
  isLoading = false,
  onLoanClick,
  className,
}: LoanCentricSidebarNavViewProps) {
  return (
    <nav
      className={classNames("loan-centric-sidebar-nav", className)}
      aria-label="Loan navigation"
      data-testid="loan-centric-sidebar-nav"
    >
      <div className="loan-centric-sidebar-nav__body">
        <MainSidebarSection />

        <SidebarDivider />

        <SidebarSection title="LOAN">
          {isLoading ? (
            <p className="loan-centric-sidebar-nav__loading label-medium-regular" data-testid="loan-sidebar-loading">
              Loading loans...
            </p>
          ) : (
            <ul className="loan-centric-sidebar-nav__loan-list">
              {loans.map((loan) => (
                <li key={loan.id}>
                  <LoanNavItem
                    icon={loan.icon}
                    label={loan.label}
                    baseState={loan.baseState}
                    isActive={loan.isActive}
                    onClick={onLoanClick ? () => onLoanClick(loan.id) : undefined}
                  />
                </li>
              ))}
            </ul>
          )}
        </SidebarSection>
      </div>

      <SidebarDivider />

      <SidebarSection title="PROFILE" titleVariant="profile" className="loan-centric-sidebar-nav__profile-section">
        {profileItems.map((item) => (
          <SidebarNavItem key={item.id} label={item.label} onClick={item.onClick} />
        ))}
      </SidebarSection>
    </nav>
  );
}
